import React from "react";

import ReactFlow, {
  addEdge,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
} from "react-flow-renderer";

import css from "../css/pseudoclasses.css";

import {
  nodes as initialNodes,
  edges as initialEdges,
} from "../flowcharts/pseudo-classes-page-elements";

const onInit = (reactFlowInstance) =>
  console.log("flow loaded:", reactFlowInstance);

const OverviewFlow = () => {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const onConnect = (params) => setEdges((eds) => addEdge(params, eds));

  return (
    <div
      className="pseudoclasses-page"
      style={{
        height: "2000px",
        // width: "390vh",
      }}
    >
      {/* <div id="stars"></div>
      <div id="stars2"></div> */}
      <div id="stars3"></div>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        onInit={onInit}
        fitView={true}
        minZoom={0.2}
        attributionPosition="bottom-right"
      >
        {/* //enable below if you want minimap */}
        <MiniMap
          className="minimap-controls"
          nodeStrokeColor={(n) => {
            if (n.style?.background) return n.style.background;
            if (n.type === "input") return "#0041d0";
            if (n.type === "output") return "#ff0072";
            if (n.type === "default") return "#1a192b";

            return "#eee";
          }}
          nodeColor={(n) => {
            if (n.style?.background) return n.style.background;

            return "#fff";
          }}
          nodeBorderRadius={2}
        />
        <Controls className="react-flow-controls" />
        {/* <Background color="#aaa" gap={16} /> */}
      </ReactFlow>
    </div>
  );
};

export default OverviewFlow;
